import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Data Kitchen';
const SITE_URL = 'https://datakitchen.com.au';
const DEFAULT_DESCRIPTION = 'Boutique enterprise data consulting. Senior-led, outcomes-focused, and independent of vendor partnerships.';

export default function SEO({ title, description, path = '' }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Enterprise Data Consulting`;
  const metaDescription = description || DEFAULT_DESCRIPTION;
  const canonical = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
    </Helmet>
  );
}
